var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('a-table',{attrs:{"columns":_vm.cols,"data-source":_vm.tabledata}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }